

/// <reference path="TipPool.ts" />

// Generated class DepartmentPool_ManagedObject

class DepartmentPool_ManagedObject extends TipPool
{

    // Property: departmentName
    set departmentName(value:string) {
        this.setValueForKey(value, 'departmentName');
    }
    get departmentName():string {
        return this.valueForKey('departmentName');
    }
    set departmentNamePrimitiveValue(value:string) {
        this.setPrimitiveValueForKey(value, 'departmentName');
    }
    get departmentNamePrimitiveValue():string {
        return this.primitiveValueForKey('departmentName');
    }
    // Relationship: department
    set department(value:Department) {
        this.setValueForKey(value, 'department');
    }
    get department():Department {
        return this.valueForKey('department') as Department;
    }
}
